import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  EditButton,
  Edit,
  ChipField,
  ReferenceInput,
  SelectInput,
  TextInput,
  Create,
  Filter,
  TabbedForm,
  FormTab,
  Responsive,
  DeleteButton,
  BooleanInput,
  BooleanField,
} from "react-admin";

import RichTextInput from "ra-input-rich-text";

const JobFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search (headline)" source="headline" alwaysOn />
    <ReferenceInput
      label="Country"
      source="country"
      reference="countries"
      allowEmpty
    >
      <SelectInput optionText="description" />
    </ReferenceInput>
    <ReferenceInput label="Area" source="area" reference="areas" allowEmpty>
      <SelectInput optionText="description" />
    </ReferenceInput>
  </Filter>
);

const JobTitle = ({ record }) => {
  return <span>Job {record ? `"${record.id}"` : ""}</span>;
};

export const JobList = (props) => (
  <List title="Jobs" {...props} filters={<JobFilter />} exporter={false} bulkActionButtons={false}>
    <Responsive
      large={
        <Datagrid>
          <TextField label="Headline" source="headline" />
          <ReferenceField
            label="Country"
            source="country"
            reference="countries"
          >
            <ChipField source="description" />
          </ReferenceField>
          <TextField label="City" source="city" />
          <ReferenceField label="Area" source="area" reference="areas">
            <ChipField source="description" />
          </ReferenceField>
          <BooleanField source="published" />
          <DateField
            label="Last Update"
            source="lastupdate"
            locales="lt"
          />
          <EditButton label="" />
          <DeleteButton label="" />
        </Datagrid>
      }
      medium={
        <Datagrid>
          <TextField source="id" />
          <TextField label="Headline" source="headline" />
          <ReferenceField
            label="Country"
            source="country"
            reference="countries"
          >
            <ChipField source="description" />
          </ReferenceField>
          <TextField label="City" source="city" />
          <ReferenceField label="Area" source="area" reference="areas">
            <ChipField source="description" />
          </ReferenceField>
          <BooleanField source="published" />
          <DateField
            label="Last Update"
            source="lastupdate"
            locales="lt"
            showTime
          />
          <EditButton label="" />
          <DeleteButton label="" />
        </Datagrid>
      }
      small={
        <Datagrid>
          <TextField source="id" />
          <TextField label="Headline" source="headline" />
          <ReferenceField
            label="Country"
            source="country"
            reference="countries"
          >
            <ChipField source="description" />
          </ReferenceField>
          <TextField label="City" source="city" />
          <ReferenceField label="Area" source="area" reference="areas">
            <ChipField source="description" />
          </ReferenceField>
          <DateField
            label="Data de Atualização"
            source="lastupdate"
            locales="lt"
            showTime
          />
          <EditButton label="" />
          <DeleteButton label="" />
        </Datagrid>
      }
    />
  </List>
);

export const JobEdit = (props) => (
  <Edit title={<JobTitle />} {...props}>
    <TabbedForm>
      <FormTab label="Localization">
        <TextField source="id" label="Id" />
        <ReferenceInput
          allowEmpty
          label="Country"
          source="country"
          reference="countries"
        >
          <SelectInput optionText="description" />
        </ReferenceInput>
        <TextInput label="City" source="city" />
        <BooleanInput source="published" />
      </FormTab>
      <FormTab label="Post">
        <ReferenceInput allowEmpty label="Area" source="area" reference="areas">
          <SelectInput optionText="description" />
        </ReferenceInput>
        <TextInput label="Headline" source="headline" />
        <RichTextInput label="Body" source="body" />
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Edit>
);

export const JobCreate = (props) => (
  <Create title="Create Job" {...props}>
    <TabbedForm>
      <FormTab label="Localization">
        <TextInput source="id" label="Id" />
        <ReferenceInput label="Country" source="country" reference="countries">
          <SelectInput optionText="description" />
        </ReferenceInput>
        <TextInput label="City" source="city" />
        <BooleanInput source="published" />
      </FormTab>
      <FormTab label="Job">
        <ReferenceInput allowEmpty label="Area" source="area" reference="areas">
          <SelectInput optionText="description" />
        </ReferenceInput>
        <TextInput label="Headline" source="headline" />
        <RichTextInput label="Body" source="body" />
        <DateField
          label="Create Date"
          source="createdate"
          locales="lt"
          showTime
        />
        <DateField
          label="Last Update"
          source="lastupdate"
          locales="lt"
          showTime
        />
      </FormTab>
    </TabbedForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/jobs.js